//import {Gatekeeper} from 'gatekeeper-client-sdk';
import axios from '@app/services/axios';
import {LOGIN_METHOD, verify_token_METHOD} from '@app/const/AppSetting';

export const loginByAuth = async (email, password) => {
    // const token = await Gatekeeper.loginByAuth(email, password);
    //const firebaseToken = localStorage.getItem(`firebaseToken`);
    const lo = {
        Username: email,
        Password: password,
        isAndroid:1,
     //   firebaseToken: firebaseToken
    };

    const v = await axios.post(LOGIN_METHOD, lo);
    console.log(JSON.stringify(v.data, null, 2));
    const token = v.data.accessToken;

    if(v.data.flag)
    {
        localStorage.setItem('token', token);
        localStorage.setItem('profile', JSON.stringify(v.data, null, 2) );
        document.getElementById('root').classList.remove('login-page');
        document.getElementById('root').classList.remove('hold-transition');
    }
    return v.data;
};

export const verify_token = async () => {
    // const token = await Gatekeeper.loginByAuth(email, password);
    //const firebaseToken = localStorage.getItem(`firebaseToken`);
    const lo = {
        Username: '',
        Password: '',
        isAndroid:1,
       // firebaseToken: firebaseToken
    };

    const v = await axios.post(verify_token_METHOD, {});
    if(v && v.data )
    {
        return v.data;
    }
    else
        return {flag:true, msg: 'Không thể kết nối tới server' };

};

export const registerByAuth = async (email, password) => {
  /*  const token = await Gatekeeper.registerByAuth(email, password);
    localStorage.setItem('token', token);
    document.getElementById('root').classList.remove('register-page');
    document.getElementById('root').classList.remove('hold-transition');
    return token;*/
    return null;
};

export const loginByGoogle = async () => {
    /*const token = await Gatekeeper.loginByGoogle();
    localStorage.setItem('token', token);
    document.getElementById('root').classList.remove('login-page');
    document.getElementById('root').classList.remove('hold-transition');
    return token;*/ return null;
};

export const registerByGoogle = async () => {
    /*const token = await Gatekeeper.registerByGoogle();
    localStorage.setItem('token', token);
    document.getElementById('root').classList.remove('register-page');
    document.getElementById('root').classList.remove('hold-transition');
    return token;*/ return null;
};

export const loginByFacebook = async () => {
    /*const token = await Gatekeeper.loginByFacebook();
    localStorage.setItem('token', token);
    document.getElementById('root').classList.remove('login-page');
    document.getElementById('root').classList.remove('hold-transition');
    return token;*/ return null;
};

export const registerByFacebook = async () => {
   /*c const token = await Gatekeeper.registerByFacebook();
    localStorage.setItem('token', token);
    document.getElementById('root').classList.remove('register-page');
    document.getElementById('root').classList.remove('hold-transition');
    return token;*/ return null;
};
